import React from 'react'
import { Card } from 'react-bootstrap'

const HomeOfficeBanner = () => {
  return (
    <>
    <Card className='no-border rounded-0 text-center py-5 py-md-0'>
        <Card.Title className='home-office-title'> ホームオフィス </Card.Title>
        <Card.Img src={"/assets/digital-twin/images/office.jpg"} alt="Card image" className="banner-image rounded-0"  />
    </Card>
      
    </>
  )
}

export default HomeOfficeBanner
